import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import Index from "./pages/Index";

// Lazy load pages that are not immediately needed
const NotFound = lazy(() => import("./pages/NotFound"));
const Noticias = lazy(() => import("./pages/Noticias"));
const NoticiaDetalhe = lazy(() => import("./pages/NoticiaDetalhe"));
const Tributario = lazy(() => import("./pages/Tributario"));
const IsencaoImpostoRenda = lazy(() => import("./pages/servicos/IsencaoImpostoRenda"));
const RevisaoImpostoRenda = lazy(() => import("./pages/servicos/RevisaoImpostoRenda"));
const RevisaoItbiIptuIss = lazy(() => import("./pages/servicos/RevisaoItbiIptuIss"));
const HoldingSucessaoPatrimonial = lazy(() => import("./pages/servicos/HoldingSucessaoPatrimonial"));
const AdminLogin = lazy(() => import("./pages/admin/AdminLogin"));
const AdminDashboard = lazy(() => import("./pages/admin/AdminDashboard"));

// App (Assistente Jurídico) - DESATIVADO até segunda ordem
const AppDisabled = lazy(() => import("./pages/app/AppDisabled"));


const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={<div className="min-h-screen bg-background" />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/tributario" element={<Tributario />} />
            <Route path="/noticias" element={<Noticias />} />
            <Route path="/noticias/:slug" element={<NoticiaDetalhe />} />
            <Route path="/servicos/isencao-imposto-renda" element={<IsencaoImpostoRenda />} />
            <Route path="/servicos/revisao-imposto-renda" element={<RevisaoImpostoRenda />} />
            <Route path="/servicos/revisao-itbi-iptu-iss" element={<RevisaoItbiIptuIss />} />
            <Route path="/servicos/holding-sucessao-patrimonial" element={<HoldingSucessaoPatrimonial />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            {/* App - Assistente Jurídico (DESATIVADO) */}
            <Route path="/app" element={<AppDisabled />} />
            <Route path="/app/*" element={<AppDisabled />} />

            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
